import {Module} from '@fantasmagames/slot/src/common/Module';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {SwipeInteractionEvents} from '@fantasmagames/slot/src/modules/swipeinteraction/SwipeInteractionEvents';

export class RecodeAnalyticsModule extends Module<null> {
	protected _lastSpinInteractionMethod: string;
	protected _isInAutoplay: boolean = false;
	protected _isSpinStartedSwiping: boolean = false;
	protected _isFreeSpinsStarted: boolean = false;
	protected _wasQuickSpin: boolean = false;

	public init(): void {
		super.init();

		this.setCurrentModes();

		this.soundPlayer.allSoundsStatusChangedCallback = this.onAllSoundsStatusChanged.bind(this);
		this.soundPlayer.backgroundMusicStatusChangedCallback = this.onBackgroundMusicStatusChanged.bind(this);
		this.soundPlayer.gameSoundsStatusChangedCallback = this.onGameSoundsStatusChanged.bind(this);
	}

	protected setCurrentModes(): void {
		(window as any).V.API.SlotAnalytics.setCurrencyMode('Credits');
		(window as any).V.API.SlotAnalytics.setQuickSpins(false);
		(window as any).V.API.SlotAnalytics.setGameSounds(true);
		(window as any).V.API.SlotAnalytics.setBackgroundSounds(true);
		(window as any).V.API.SlotAnalytics.setWinSounds(false);
	}

	protected enterFirstState(): void {}
	protected setupStates(): void {}

	protected setupEvents(): void {
		this.on(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinStarted);
		this.on(LogicEvents.SPIN_RESPONSE, this.onSpinDataReceived);
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);

		this.on(FlowModuleEvents.FREESPINS_WIN, this.onFreeSpinsWin);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsFinished);

		this.on(SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED, this.onSpinStartedByAutoplay);
		this.on(SwipeInteractionEvents.START_SPIN, this.onSwipe);

		this.on(SpinButtonEvents.QUICKSTOP_PRESSED, this.onQuickstopPressed);
	}

	protected onQuickstopPressed(): void {
		this._wasQuickSpin = true;
	}

	protected onFreeSpinsWin(): void {
		this._isFreeSpinsStarted = true;
	}

	protected onFreeSpinsFinished(): void {
		this._isFreeSpinsStarted = false;
	}

	protected setupViews(): void {}

	protected onSwipe(): void {
		this._isSpinStartedSwiping = true;
	}

	protected onSpinStartedByAutoplay(): void {
		this._isInAutoplay = true;
	}

	protected onSpinStarted(): void {
		(window as any).V.API.SlotAnalytics.startSpinEvent();

		if (this._isFreeSpinsStarted) {
			this._lastSpinInteractionMethod = 'FreeSpin';
		} else if (this._isInAutoplay) {
			this._lastSpinInteractionMethod = 'AutoPlay';
		} else if (this._isSpinStartedSwiping) {
			this._lastSpinInteractionMethod = 'Swipe';
		} else if (this.device.isMobile) {
			this._lastSpinInteractionMethod = 'Tap';
		} else {
			this._lastSpinInteractionMethod = 'Click';
		}

		this._wasQuickSpin = false;
		this._isSpinStartedSwiping = false;
		this._isInAutoplay = false;
	}

	protected onSpinDataReceived(): void {
		const transNumber: string = (this.logic as RecodeLogic).transNumber;
		const CI = (window as any).V.API.GameAnalytics.ContextItems;
		(window as any).V.API.GameAnalytics.setContextData(CI.KEY_TRANSACTION_ID, Number.parseInt(transNumber, 10));
	}

	protected onCanSpin(): void {
		(window as any).V.API.SlotAnalytics.sendSpinEvent(this._lastSpinInteractionMethod, false);
	}

	protected onAllSoundsStatusChanged(isEnabled: boolean): void {
		(window as any).V.API.SlotAnalytics.setBackgroundSounds(isEnabled);
		(window as any).V.API.SlotAnalytics.setGameSounds(isEnabled);
	}

	protected onBackgroundMusicStatusChanged(isEnabled: boolean): void {
		(window as any).V.API.SlotAnalytics.setBackgroundSounds(isEnabled);
	}

	protected onGameSoundsStatusChanged(isEnabled: boolean): void {
		(window as any).V.API.SlotAnalytics.setGameSounds(isEnabled);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/integration/analytics/RecodeAnalyticsModule.ts